import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { switchMap, map, catchError, withLatestFrom, tap, ignoreElements } from 'rxjs/operators';
import { initialPageableQuery } from '../models';
import { selectCanReadSystemWorkspaces } from '../user/selectors';
import authActions from '../auth/actions';
import actions from './actions';
import { getWorkspaces, getWorkspaceOrganizations, getWorkspaceById, resetWorkspacesEndpointFallback } from './services';

// Logout does not reload the page, so without this the next user in the same tab inherits the
// previous user's 403 and stays pinned to the account endpoint.
export const handleResetWorkspacesEndpoint = action$ =>
  action$.pipe(ofType(authActions.LOGOUT_SUCCESS), tap(resetWorkspacesEndpointFallback), ignoreElements());

export const handleLoadWorkspaces = (action$, state$) =>
  action$.pipe(
    ofType(actions.LOAD_WORKSPACES),
    withLatestFrom(state$.pipe(map(selectCanReadSystemWorkspaces))),
    switchMap(([action, canReadSystemWorkspaces]: [{ payload?: { search?: string } }, boolean]) =>
      getWorkspaces(action.payload?.search, canReadSystemWorkspaces).pipe(
        map(workspaces => actions.loadWorkspacesSuccess(workspaces)),
        catchError(err => of(actions.loadWorkspacesFailure(err?.message ?? 'load_workspaces_error')))
      )
    )
  );

export const handleLoadWorkspaceById = action$ =>
  action$.pipe(
    ofType(actions.LOAD_WORKSPACE_BY_ID),
    switchMap((action: { payload: { workspaceId: string } }) =>
      getWorkspaceById(action.payload.workspaceId).pipe(
        map(workspace => actions.loadWorkspaceByIdSuccess(workspace)),
        catchError(err => of(actions.loadWorkspaceByIdFailure(err?.message ?? 'load_workspace_by_id_error')))
      )
    )
  );

export const handleLoadWorkspaceOrgs = action$ =>
  action$.pipe(
    ofType(actions.LOAD_WORKSPACE_ORGS),
    switchMap((action: { payload: { workspaceId: string } }) =>
      getWorkspaceOrganizations(initialPageableQuery, action.payload.workspaceId).pipe(
        map(response => actions.loadWorkspaceOrgsSuccess(action.payload.workspaceId, response.data.content)),
        catchError(err => of(actions.loadWorkspaceOrgsFailure(err?.message ?? 'load_workspace_orgs_error')))
      )
    )
  );
